<template>
  <div class="employe-operation-record">
    <div class="operation-main">
      <div class="main-top">
        <div class="top-left">
          <el-button @click="inToday">今天</el-button>
          <el-button @click="inYesterday">昨天</el-button>
          <el-button @click="inSevenDays">近7天</el-button>
          <el-date-picker
            align="center"
            v-model="dateRange"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            @change="getEntityChangeList"
          ></el-date-picker>
          <el-select
            v-model="query.entityChangeType"
            clearable
            placeholder="操作类型"
            @change="getEntityChangeList"
          >
            <el-option
              v-for="item in entityChangeTypeDic"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="top-right">
        </div>
      </div>
      <el-table :data="operationForm" style="width: 100%">
        <el-table-column
          prop="userName"
          label="操作者"
          width="150"
        >
          <template slot-scope="props">
            {{ props.$index + 1 }}
            <span class="user-name">
              
            {{ props.row.userName | nullValue }}
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="changeType"
          label="操作类型"
          width="100"
        >
          <template slot-scope="props">
            {{ props.row.entityChange.changeType==1?"更新用户信息":(props.row.entityChange.changeType==0?"创建用户信息":"删除用户信息") | nullValue }}
          </template>
        </el-table-column> -->
        <el-table-column
          prop="propertyDisplayName"
          label="属性名"
          min-width="130"
          show-overflow-tooltip
        >
          <template slot-scope="props">
            <span v-if="props.row.entityChange.propertyChanges[0]">
              {{
              props.row.entityChange.propertyChanges[0].propertyDisplayName | nullValue
            }}
            <span v-if="props.row.entityChange.propertyChanges[0]">
            ：{{ props.row.entityChange.propertyChanges[0].originalValue | nullValue }}
            改为
            {{ props.row.entityChange.propertyChanges[0].newValue | nullValue }}
            </span>
            </span>
            <span v-else>—</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="originalValue"
          label="更新内容"
          min-width="250"
          show-overflow-tooltip
        >
          <template slot-scope="props">
            
            <span v-else>—</span>
          </template>
        </el-table-column>         -->
        <el-table-column
          prop="changeTime"
          label="操作时间"
          width="200"
        >
          <template slot-scope="props">
            {{ props.row.entityChange.changeTime | nullValue }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="70" >
          <template slot-scope="scope">
            <div class="table-operation">
              <el-button
                @click.native.prevent="details(scope.row)"
                type="text"
                
                >详情</el-button
              >
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="loading-box" v-if="isLoading">
            <img
              src="@/assets/image/loading.png"
              alt="loading"
              class="loading-ico"
            />
            数据加载中...
          </div>
          <div class="empty-box" v-if="!isLoading && !operationForm.length">
            列表为空
          </div>
        </template>
      </el-table>
      <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageIndex"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="query.maxResultCount"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        ></el-pagination>
    </div>
    <el-drawer
      :with-header="false"
      :visible.sync="isDrawerShow"
      direction="rtl"
    >
      <div class="drawer-title">
        操作详情
        <span @click="isDrawerShow = false">
          <svg-icon icon-class="close-ico" />
        </span>
      </div>
      <el-table :data="propertyChanges" style="width: 100%">
        <el-table-column
          prop="propertyDisplayName"
          label="属性名"
          min-width="150"
          show-overflow-tooltip
        >
          <template slot-scope="props">
            {{ props.row.propertyDisplayName | nullValue }}
          </template>
        </el-table-column>
        <el-table-column
          prop="originalValue"
          label="原始值"
          min-width="150"
          show-overflow-tooltip
        >
          <template slot-scope="props">
            {{ props.row.originalValue | nullValue }}
          </template>
        </el-table-column>
        <el-table-column
          prop="newValue"
          label="新值"
          min-width="150"
          show-overflow-tooltip
        >
          <template slot-scope="props">
            {{ props.row.newValue | nullValue }}
          </template>
        </el-table-column>
      </el-table>
    </el-drawer>
  </div>
</template>

<script>
import { getEntityChanges } from "@/http/api/auditLogs";
import moment from "moment";
export default {
  data() {
    return {
      select: "请输入操作人姓名",
      dateRange: [],

      entityChangeTypeDic: [
        {
          value: "created",
          label: "创建",
        },
        {
          value: "updated",
          label: "更改",
        },
        {
          value: "deleted",
          label: "删除",
        },
      ],
      operationForm: [],
      propertyChanges: [],
      isLoading: true,
      isDrawerShow: false,
      pageIndex:1,
      totalCount:0,
      query: {
        maxResultCount: 30,
        skipCount: 0,
        entityChangeType: "",
        startDate: null,
        endDate: null,
        entityTypeFullName: "Deer.Users.User",
        entityId: this.$route.params.id,
      },
    };
  },
  mounted() {
    this.getEntityChangeList();
  },
  methods: {
    details(row) {
      this.propertyChanges = row.entityChange.propertyChanges;
      this.isDrawerShow = true;
    },
    inToday() {
      let start = new Date(new Date().toLocaleDateString());
      let end = new Date();
      this.dateRange = [start, end];
      this.getEntityChangeList();
    },
    inYesterday() {
      let start = new Date(
        new Date(new Date().setHours(0, 0, 0, 0)) - 86400000
      );
      let end = new Date(new Date().toLocaleDateString());
      this.dateRange = [start, end];
      this.getEntityChangeList();
    },
    inSevenDays() {
      let start = new Date(new Date().getTime() - 86400000 * 7);
      let end = new Date();
      this.dateRange = [start, end];
      this.getEntityChangeList();
    },
    handleCurrentChange(val) {
      //console.log("跳转的指定页", val);
      this.pageIndex = val;
      this.getEntityChangeList();
    },
    handleSizeChange(val) {
      //console.log("更改的页面数量", val);
      this.query.maxResultCount = val;
      this.pageIndex = 1;
      this.getEntityChangeList();
    },
    handleSearchClick() {
      //console.log(this.query.search, "query.search");
    },
    getEntityChangeList() {
      this.isLoading = true;
      if (this.dateRange && this.dateRange.length > 0) {
        this.query.startDate = moment(this.dateRange[0]).format();
        this.query.endDate = moment(this.dateRange[1]).format();
      } else {
        this.query.endDate = null;
        this.query.startDate = null;
      }
      this.query.skipCount = (this.pageIndex - 1) * this.query.maxResultCount;
      getEntityChanges(this.query).then((res) => {
        this.isLoading = false;
        this.operationForm = res.result.items;
        this.totalCount = res.result.totalCount
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.employe-operation-record {
  .operation-main {
    padding: 20px;
    background: #fff;
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);

    .main-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      height: 30px;

      .top-left {
        display: flex;
        align-items: center;
        height: 100%;

        .el-button {
          margin: 0;
          border-radius: 0;
          border-right-color: transparent;
          height: 30px;

          &:focus {
            border-right-color: $--color-primary;
          }
        }
        .el-button:first-child{
          border-radius: 4px 0 0 4px;
        }
        .el-select {
          margin-left: 10px;
          width: 120px;
        }
        .el-input__inner{
           border-radius: 0 4px 4px 0;
        }
      }

      .top-right {
        display: flex;
        align-items: center;
        height: 100%;
        width: 350px;

        .el-select {
          width: 100px;
        }
      }
    }

    .el-table {
      margin-bottom: 15px;
      .user-name{
        margin-left: 20px;
        cursor: pointer;
        // color: $--color-primary;
      }
      .table-operation {
        display: flex;
        .el-button + .el-button {
          margin-left: 10px;
        }
      }

      ::v-deep .el-table__body-wrapper {
        // min-height: calc(100vh - 333px);
      }
    }
  }
  ::v-deep .el-drawer {
    width: 700px !important;
  }
}
</style>